export default function getClassWithQuery (contained : boolean, classList : string) : string {
  return contained ? classList.split(' ').map((entry) => `@${entry}`).join(' ') : classList
}
